<template>
  <v-dialog eager v-bind="$attrs" @input="$emit('input', $event)">
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <v-card>
      <v-card-title>
        <slot name="title">
          <span> Custom Homework </span>
        </slot>
        <v-spacer />
        <v-btn
          class="white--text text-capitalize"
          depressed
          color="#FF347C"
          @click="$emit('input', false)"
        >
          Close
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-title>
        <v-form ref="form" @submit.prevent>
          <v-row>
            <v-col cols="12">
              <app-editor ref="direction" v-model="crud.description" />
            </v-col>
            <v-col cols="12">
              <app-editor ref="description" v-model="crud.question_group.questions[0].content" />
            </v-col>
            <v-col cols="12">
              <div class="d-flex">
                <RecordButton :recording="recording" @click="startRecord" />
                <ButtonPlayer v-if="computedSrc" class="ml-2" :src="computedSrc" :player="false" />
              </div>

              <v-file-input accept="audio/*" label="Audio File" @change="currentAudio = $event" />
              <v-file-input
                v-model="crud.question_group.questions[0].question_doc_file"
                label="Document File"
              />
            </v-col>
            <v-btn
              text
              @click="beforeSave"
              :loading="loading || loadingAssign"
              color="#FF347C"
              class="d-flex ml-auto"
            >
              Assign to student
            </v-btn>
          </v-row>
        </v-form>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>
<script>
import Editor from "@/components/Utils/Editor.vue";
import homeworkMixin from "@/mixins/homeworkMixin";
import RecordButton from "../../RecordButton.vue";
import audioMixin from "@/mixins/audioMixin";
import ButtonPlayer from "../../ButtonPlayer.vue";

export default {
  components: {
    appEditor: Editor,
    RecordButton,
    ButtonPlayer,
  },
  props: {
    loadingAssign: Boolean,
    defaultText: {
      type: String,
      default: "Homework details here...",
    },
  },
  data() {
    return {
      currentAudio: null,
      crud: {
        type: "Custom",
        question_group: {
          questions: [
            {
              title: this.title,
              content: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        type: "text",
                        text: this.defaultText,
                      },
                    ],
                  },
                ],
              },
              question_file: undefined,
              question_doc_file: undefined,
            },
          ],
        },
      },
      defaultCrud: {
        type: "Custom",
        question_group: {
          questions: [
            {
              title: this.title,
              content: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        type: "text",
                        text: "Homework details here...",
                      },
                    ],
                  },
                ],
              },
              question_file: undefined,
              question_doc_file: undefined,
            },
          ],
        },
      },
    };
  },
  mixins: [homeworkMixin, audioMixin],
  methods: {
    startRecord() {
      this.audioUrl = null;
      this.audioBlob = null;
      this.onRecord();
    },
    async beforeSave() {
      this.crud.question_group.questions[0].question_file = this.currentAudio || undefined;
      await this.onSave();
      this.$emit("new-homework", { ...this.crud, ...this.createFields });
      this.crud = JSON.parse(JSON.stringify(this.defaultCrud));
      this.mount();
    },
    async mount() {
      let description = {
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                type: "text",
                text: "Directions here...",
              },
            ],
          },
        ],
      };
      const data = {
        ...this.data,
        question_group: {
          questions: [
            {
              title: this.title,
              content: {
                type: "doc",
                content: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        type: "text",
                        text: "Homework details here...",
                      },
                    ],
                  },
                ],
              },
            },
          ],
        },
      };

      this.crud = {
        ...data,
        description,
        teacher_lesson: this.$store.getters["lesson/teacher_lesson"].uuid,
        teacher: this.$store.getters.profile.uuid,
      };
      await this.$nextTick();
      this.currentAudio = null;
      this.$refs.direction.setContent(this.crud.description);
      this.$refs.description.setContent(this.crud.question_group.questions[0].content);
    },
    setAudio(audio) {
      this.currentAudio = audio;
    },
  },
  computed: {
    computedSrc() {
      if (typeof this.currentAudio === "string") return this.currentAudio;
      try {
        console.log(this.currentAudio);
        return URL.createObjectURL(this.currentAudio);
      } catch (error) {
        console.error(error);
        return "";
      }
    },
  },
  mounted() {
    this.mount();

    this.$on("stop-recording", () => {
      this.setAudio(this.audioBlob);
    });
  },
};
</script>
